import { render, staticRenderFns } from "./SaldoContratoVendedor.vue?vue&type=template&id=f843a2d6&"
import script from "./SaldoContratoVendedor.vue?vue&type=script&lang=js&"
export * from "./SaldoContratoVendedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports